import React, { useState, useEffect } from "react";

export default function PublicDisclosure() {
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const disclosureData = [
    {
      section: "a)",
      category: "About HEI",
      remarks: [
        {
          title: "About Us: Overview",
          links: [
            "https://www.jssuninoida.edu.in/home",
            "https://www.jssuninoida.edu.in/about-university",
          ],
          remark: "",
        },
        {
          title: "Act and Statutes or MoA",
          links: ["https://www.jssuninoida.edu.in/statutory-bodies"],
          remark: "",
        },
        {
          title: "Institutional Development Plan",
          links: ["https://www.jssuninoida.edu.in/home"],
          remark: "",
        },
        {
          title:
            "Constituent Units/Affiliated Colleges, Affiliating University (in case of Colleges) Off-Campus/Off-shore campus/Learning Support Centres under ODL mode ",
          links: [
            "https://www.jssuninoida.edu.in/school-of-engineering",
            "https://www.jssuninoida.edu.in/school-of-pharmacy",
            "https://www.jssuninoida.edu.in/school-of-management",
            "https://www.jssuninoida.edu.in/school-of-humanities",
          ],
          remark: "",
        },
        {
          title: "Accreditation/Ranking status (NAAC, NBA NIRF)",
          links: [],
          remark: "Not Applicable (New Private University Started in 2024)",
        },
        {
          title: "Recognition/Approval (2(f), 12B, etc. as applicable)",
          links: [
            "https://www.jssuninoida.edu.in/home",
            "https://jssuninoida.edu.in/assets/docs/AICTE_Approval_for_JSS_University_Noida.pdf",
          ],
          remark: "",
        },
        {
          title: "Annual Reports",
          links: [],
          remark: "(New Private University Started in 2024 - Under Process)",
        },
        {
          title:
            "Annual Account including Balance Sheet, Income and Expenditure Account, Receipts and Payments Account along with Audit Report",
          links: [],
          remark: "(New Private University Started in 2024 - Under Process)",
        },
        {
          title: "Sponsoring body details, if any",
          links: ["https://www.jssuninoida.edu.in/about-jssmvp#"],
          remark: "",
        },
      ],
    },
    {
      section: "b)",
      category: "Administration (Profiles with photograph and contact details)",
      remarks: [
        {
          title: "Chancellor",
          links: ["https://www.jssuninoida.edu.in/chancellor"],
          remark: "",
        },
        {
          title: "Pro Chancellor",
          links: ["https://www.jssuninoida.edu.in/about-pro-chancellor"],
          remark: "",
        },
        {
          title: "Vice-Chancellor",
          links: [
            "https://www.jssuninoida.edu.in/administration-vice-chancellor",
          ],
          remark: "",
        },
        { title: "Pro-Vice-Chancellor ", links: [], remark: "-" },
        {
          title: "Registrar",
          links: ["https://www.jssuninoida.edu.in/registrar-message"],
          remark: "",
        },
        {
          title: "Principle ",
          links: ["https://www.jssuninoida.edu.in/"],
          remark: "",
        },
        {
          title: "Finance Officer",
          links: ["https://www.jssuninoida.edu.in/home"],
          remark: "",
        },
        {
          title: "Controller of Examination",
          links: ["https://www.jssuninoida.edu.in/controller-of-examination"],
          remark: "",
        },
        {
          title: "Chief Vigilance Officer",
          links: ["https://www.jssuninoida.edu.in/home"],
          remark: "",
        },
        {
          title: "Ombudsperson",
          links: ["https://www.jssuninoida.edu.in/home"],
          remark: "",
        },
        {
          title:
            "Executive Council/Board of Governors by whatever name called, Board of Management, Academic Council, Board of Studies, Finance Committee- composition and members with particulars",
          links: [
            "https://jssuninoida.edu.in/assets/docs/BOS.pdf",
            "https://jssuninoida.edu.in/assets/docs/Academic_Council_Latest.pdf",
            "https://www.jssuninoida.edu.in/governing-bodies",
          ],
          remark: "",
        },
        {
          title: "Internal Complaint Committee",
          links: [
            "https://jssuninoida.edu.in/assets/docs/grievance_redressal.pdf",
          ],
          remark: "",
        },
      ],
    },
    {
      section: "c)",
      category: "Academics",
      remarks: [
        {
          title: "Details of Academic Programs",
          links: ["http://www.jssuninoida.edu.in"],
          remark: "",
        },
        {
          title: "Academic Calendar",
          links: ["https://www.jssuninoida.edu.in/calendar-of-events"],
          remark: "",
        },
        {
          title: "Statutes/Ordinances pertaining to Academic/Examinations",
          links: [
            "https://jssuninoida.edu.in/assets/docs/regulation_btech.pdf",
            "https://jssuninoida.edu.in/assets/docs/Rev_02_JSS_University_Noida_B.Pharma_Examination_regulations.pdf",
            "https://jssuninoida.edu.in/assets/docs/regulation_mpharma.pdf",
            "https://jssuninoida.edu.in/assets/docs/Rev_00_JSS_University_Noida_D.Pharma_Examination_regulations.pdf",
            "https://jssuninoida.edu.in/assets/docs/regulation_mca.pdf",
            "https://jssuninoida.edu.in/assets/docs/PhD_REGULATIONS.pdf",
          ],
          remark: "",
        },
        {
          title: "Schools/Departments/Centres",
          links: [
            "https://www.jssuninoida.edu.in/school-of-engineering",
            "https://www.jssuninoida.edu.in/faculty-of-engg-tech",
          ],
          remark: "",
        },
        {
          title:
            "Schools/Departments/Centres faculty wise/staff details with photographs",
          links: [
            "https://www.jssuninoida.edu.in/school-of-pharmacy",
            "https://www.jssuninoida.edu.in/school-of-management",
            "https://www.jssuninoida.edu.in/school-of-humanities",
            "https://www.jssuninoida.edu.in/school-of-life-sciences",
          ],
          remark: "",
        },
        {
          title: "List of UGC-recognized ODL/Online programs, if any",
          links: [],
          remark: "Not Applicable (New Private University Started in 2024)",
        },
        {
          title: "Internal Quality Assurance Cell (IQAC)",
          links: ["https://www.jssuninoida.edu.in/iqac"],
          remark: "",
        },
        {
          title: "Library",
          links: ["https://www.jssuninoida.edu.in/library-information-centre"],
          remark: "",
        },
        {
          title: "Academic collaboration",
          links: ["https://www.jssuninoida.edu.in/placement-statistics"],
          remark: "",
        },
      ],
    },
    {
      section: "d)",
      category: "Admission & Fee",
      remarks: [
        {
          title: "Prospectus (including fee structure for various programs)",
          links: [
            "https://www.jssuninoida.edu.in/fee-structure",
            "https://studentportal.universitysolutions.in/index.html",
          ],
          remark: "",
        },
        {
          title: "Admission process and guidelines",
          links: [
            "https://www.jssuninoida.edu.in/admission-criteria",
            "https://www.jssuninoida.edu.in/admission-main",
            "https://docs.google.com/forms/d/e/1FAIpQLSfTOEaKuAJ81q1vbtoAquwTmhK7o8kJ1GWLZcIBu7_sDnGc3Q/viewform",
          ],
          remark: "",
        },
        {
          title: "Fee refund policy",
          links: ["https://www.jssuninoida.edu.in/admission-main#"],
          remark: "",
        },
      ],
    },
    {
      section: "e)",
      category: "Research",
      remarks: [
        {
          title:
            "Research and Development Cell (including research and Consultancy Projects, Foreign Collaboration Industry Collaborations)",
          links: [
            "https://www.jssuninoida.edu.in/home",
            "https://www.jssuninoida.edu.in/research-facilities",
            "https://www.jssuninoida.edu.in/step-info",
          ],
          remark: "",
        },
        {
          title: "Incubation Centre/Start-ups/Entrepreneurship Cell",
          links: ["https://www.jssuninoida.edu.in/step-info"],
          remark: "(New Private University Started in 2024)",
        },
        {
          title: "Central facilities",
          links: [
            "https://www.jssuninoida.edu.in/research-facilities",
            "https://www.jssuninoida.edu.in/step-info",
          ],
          remark: "",
        },
      ],
    },
    {
      section: "f)",
      category: "Student Life",
      remarks: [
        {
          title: "Sports facilities",
          links: ["https://www.jssuninoida.edu.in/sports-facilities"],
          remark: "",
        },
        { title: "NCC/NSS - Details", links: [], remark: "" },
        {
          title: "Hostel details ",
          links: ["https://www.jssuninoida.edu.in/hostel-facilities"],
          remark: "",
        },
        {
          title: "Placement Cell and its activities",
          links: ["https://www.jssuninoida.edu.in/placement-statistics"],
          remark: "",
        },
        {
          title:
            "Details of Student Grievance Redressal Committee (SGRC) and Ombudsperson",
          links: [
            "https://jssuninoida.edu.in/assets/docs/grievance_redressal.pdf",
            "https://docs.google.com/forms/d/e/1FAIpQLSdqHNGC_-cTL4NV3t-X9XXgS3ge8ZPdkW2geI6VEoXEZunmDw/viewform",
          ],
          remark: "",
        },
        {
          title: "Health Facilities",
          links: ["https://www.jssuninoida.edu.in/medical-facilities"],
          remark: "",
        },
        {
          title: "Internal Complaint Committee",
          links: [
            "https://docs.google.com/forms/d/e/1FAIpQLSdqHNGC_-cTL4NV3t-X9XXgS3ge8ZPdkW2geI6VEoXEZunmDw/viewform",
            "https://jssuninoida.edu.in/assets/docs/grievance_redressal.pdf",
          ],
          remark: "",
        },
        {
          title: "Anti-Ragging Cell",
          links: [
            "https://jssuninoida.edu.in/assets/docs/ant_ragging_committe.pdf",
          ],
          remark: "",
        },
        {
          title: "Equal Opportunity Cell",
          links: ["https://www.jssuninoida.edu.in/home"],
          remark: "",
        },
        {
          title: "Socio-Economically Disadvantage Groups Cell (SEDG)",
          links: ["https://www.jssuninoida.edu.in/mentoring"],
          remark: "",
        },
        {
          title:
            "Facilities for differently-abled (e.g., barrier-free environment)",
          links: ["https://www.jssuninoida.edu.in/home"],
          remark: "",
        },
      ],
    },
    {
      section: "g)",
      category: "Alumni",
      remarks: [
        {
          title: "Alumni Association with details",
          links: ["http://jssaten.ac.in//pview/alumni"],
          remark: "",
        },
      ],
    },
    {
      section: "h)",
      category: "Information Corner",
      remarks: [
        {
          title:
            "RTI: Details of Central Public Information Officer (CPIO) and Appellate Authority ",
          links: ["https://www.jssuninoida.edu.in/home"],
          remark: "(New Private University Started in 2024 - under process)",
        },
        {
          title: "Circulars and Notices",
          links: [
            "https://www.jssuninoida.edu.in/examination-circulars",
            "https://www.jssuninoida.edu.in/media-coverage",
            "https://www.jssuninoida.edu.in/ads-archive",
          ],
          remark: "",
        },
        {
          title: "Announcements",
          links: [
            "https://www.jssuninoida.edu.in/ads-archive",
            "https://www.jssuninoida.edu.in/home",
          ],
          remark: "",
        },
        {
          title: "Newsletters",
          links: ["https://www.jssuninoida.edu.in/university-news-letter"],
          remark: "",
        },
        {
          title: "News, Recent events & Achievements",
          links: ["https://www.jssuninoida.edu.in/photo-gallerY"],
          remark: "",
        },
        {
          title: "Job openings",
          links: ["https://www.jssuninoida.edu.in/home"],
          remark: "",
        },
        {
          title: "Reservation Roster ",
          links: ["https://www.jssuninoida.edu.in/home"],
          remark: "",
        },
        {
          title: "Study in India",
          links: ["https://www.jssuninoida.edu.in/home"],
          remark: "",
        },
        {
          title:
            "Admission procedure and facilities provided to International Students",
          links: [
            "https://www.jssuninoida.edu.in/admission-main",
            "https://www.jssuninoida.edu.in/admission-criteria",
          ],
          remark: "",
        },
      ],
    },
    {
      section: "i)",
      category: "Picture Gallery",
      remarks: [
        {
          title:
            "Details with Phone Number, Official Email ID and Address, Location map",
          links: [
            "https://www.jssuninoida.edu.in/contact-us",
            "https://www.jssuninoida.edu.in/admission-helpdesk-contact",
          ],
          remark: "",
        },
        {
          title: "Telephone Directory",
          links: ["https://www.jssuninoida.edu.in/contact-us"],
          remark: "",
        },
      ],
    },
  ];

  return (
    <div
      style={{
        padding: "20px",
        marginTop: windowWidth < 768 ? "50px" : "300px",
        marginBottom: "50px",
      }}
    >
      <h1
        style={{
          fontSize: "1.875rem",
          fontWeight: "bold",
          marginBottom: "1rem",
        }}
      >
        JSS University Public Disclosure
      </h1>
      <p style={{ marginBottom: "1.5rem" }}>
        Public disclosure information for JSS University, Noida, as per the
        guidelines for Higher Education Institutions.
      </p>
      <p style={{ marginBottom: "1.5rem" }}>
       Mandatory Disclosures - <a href="https://jssuninoida.edu.in\assets\docs\MandatoryDisclosure.pdf" target="_blank">click here </a>
      </p>
      <div style={{ overflowX: "auto" }}>
        <table style={{ width: "100%", borderCollapse: "collapse" }}>
          <thead style={{ background: "#0054a4", color: "#fff" }}>
            <tr>
              <th style={{ padding: "10px", border: "1px solid #ddd" }}>
                S.No.
              </th>
              <th style={{ padding: "10px", border: "1px solid #ddd" }}>
                Guidelines on Public Self-Disclosure
              </th>
              <th style={{ padding: "10px", border: "1px solid #ddd" }}>
                Links
              </th>
              <th style={{ padding: "10px", border: "1px solid #ddd" }}>
                Remarks
              </th>
            </tr>
          </thead>
          <tbody>
            {disclosureData.map((section, index) =>
              section.remarks.map((remark, subIndex) => (
                <tr key={`${index}-${subIndex}`} style={{ textAlign: "left" }}>
                  <td style={{ padding: "10px", border: "1px solid #ddd" }}>
                    {subIndex === 0 ? section.section : ""}
                  </td>
                  <td style={{ padding: "10px", border: "1px solid #ddd" }}>
                    {subIndex === 0 ? section.category : remark.title}
                  </td>
                  <td style={{ padding: "10px", border: "1px solid #ddd" }}>
                    {remark.links.length > 0 ? (
                      <ul
                        style={{ listStyleType: "disc", paddingLeft: "20px" }}
                      >
                        {remark.links.map((link, linkIndex) => (
                          <li key={linkIndex}>
                            <a
                              href={link}
                              target="_blank"
                              rel="noopener noreferrer"
                              style={{ color: "#0000FF" }}
                            >
                              {link}
                            </a>
                          </li>
                        ))}
                      </ul>
                    ) : (
                      "-"
                    )}
                  </td>
                  <td style={{ padding: "10px", border: "1px solid #ddd" }}>
                    {remark.remark || ""}
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
      <div style={{ marginTop: "1.5rem" }}>
        <p style={{ fontWeight: "bold" }}>Registrar</p>
        <p>JSS University, Noida</p>
      </div>
    </div>
  );
}
